var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayWallet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 4.50098H2.6775C2.51465 4.5325 2.34684 4.52761 2.18609 4.48667C2.02535 4.44573 1.87565 4.36975 1.74771 4.26418C1.61977 4.1586 1.51676 4.02604 1.44606 3.87599C1.37536 3.72594 1.33871 3.5621 1.33875 3.39623V3.37485L15.75 2.81348V1.47473C15.7735 1.27499 15.7513 1.07252 15.6851 0.882609C15.6189 0.692701 15.5104 0.520322 15.3678 0.378488C15.2252 0.236655 15.0522 0.129074 14.862 0.0638715C14.6717 -0.00133121 14.4691 -0.0224517 14.2695 0.00210492L1.47375 2.08223C1.0419 2.24165 0.669196 2.52944 0.405736 2.90693C0.142277 3.28442 0.000688095 3.73352 0 4.19385L0 16.3124C0 16.7599 0.17779 17.1891 0.494257 17.5056C0.810725 17.8221 1.23995 17.9999 1.6875 17.9999H16.3125C16.7601 17.9999 17.1893 17.8221 17.5057 17.5056C17.8222 17.1891 18 16.7599 18 16.3124V6.17611L18.0011 6.12998C18.0011 5.69735 17.8293 5.28243 17.5233 4.97651C17.2174 4.67059 16.8025 4.49873 16.3699 4.49873L16.3102 4.49986L16.3125 4.50098ZM14.625 12.376C14.1773 12.3758 13.748 12.1978 13.4315 11.8812C13.1151 11.5645 12.9374 11.1351 12.9375 10.6874C12.9376 10.2397 13.1156 9.81035 13.4323 9.49388C13.749 9.17741 14.1784 8.99971 14.6261 8.99986C14.8478 8.99993 15.0673 9.04366 15.2721 9.12857C15.4769 9.21347 15.6629 9.33787 15.8196 9.49467C15.9763 9.65148 16.1006 9.83761 16.1853 10.0424C16.2701 10.2473 16.3137 10.4668 16.3136 10.6885C16.3136 10.9102 16.2698 11.1297 16.1849 11.3344C16.1 11.5392 15.9756 11.7253 15.8188 11.882C15.662 12.0387 15.4759 12.1629 15.271 12.2477C15.0662 12.3325 14.8467 12.3761 14.625 12.376Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayWallet);
export default __webpack_public_path__ + "static/media/gray-wallet.80203b3900cc5429358625ab386daaef.svg";
export { ForwardRef as ReactComponent };